import {
  FaUserShield,
  FaMapMarkerAlt,
  FaBriefcase,
  FaHardHat,
} from 'react-icons/fa';
import { GiOfficeChair } from 'react-icons/gi';

export const roleConfig = {
  schemeAdmin: {
    label: 'Office In Charge (OIC)',
    icon: FaUserShield,
    color: 'blue',
    description: 'Can manage users for assigned schemes',
    requiresSchemes: true,
    requiresFileTypes: false,
    requiresTahsils: false,
    departmentType: 'multiple',
    allowedSchemes: 'all',
    canBeCreatedBy: ['admin'],
  },
  talukaUser: {
    label: 'Tehsildar',
    icon: FaMapMarkerAlt,
    color: 'green',
    description: 'For taluka-level operations',
    requiresSchemes: true,
    requiresFileTypes: false,
    requiresTahsils: true,
    departmentType: 'single',
    allowedSchemes: 'general',
    canBeCreatedBy: ['admin', 'schemeAdmin'],
  },
  departmentOfficer: {
    label: 'Department Officer',
    icon: FaBriefcase,
    color: 'teal',
    description: 'Department-level officer',
    requiresSchemes: true,
    requiresFileTypes: false,
    requiresTahsils: false,
    departmentType: 'single',
    allowedSchemes: 'general',
    canBeCreatedBy: ['admin'],
  },
  projectOfficer: {
    label: 'Project Officer',
    icon: FaHardHat,
    color: 'purple',
    description: 'For PM-JANMAN scheme only',
    requiresSchemes: true,
    requiresFileTypes: true,
    requiresTahsils: false,
    departmentType: 'single',
    allowedSchemes: 'pmJanman',
    canBeCreatedBy: ['admin', 'schemeAdmin'],
  },
  subDivisionalOfficer: {
    label: 'Sub Divisional Officer',
    icon: GiOfficeChair,
    color: 'red',
    description: 'For Land Acquisition & Big Projects scheme only',
    requiresSchemes: true,
    requiresFileTypes: true,
    requiresTahsils: false,
    departmentType: 'single',
    allowedSchemes: 'landAcquisition',
    canBeCreatedBy: ['admin', 'schemeAdmin'],
  },
};

export const schemeRoleMapping = {
  '68ee2171ad9b09bdda13b4f6': {
    name: 'PM-JANMAN',
    type: 'pmJanman',
    allowedRoles: ['projectOfficer', 'departmentOfficer', 'schemeAdmin'],
    color: 'purple',
    description: 'Project Officer only scheme',
  },
  '68d135b1e18cfc3e5248edc2': {
    name: 'Land Acquisition & Big Projects',
    type: 'landAcquisition',
    allowedRoles: ['subDivisionalOfficer', 'departmentOfficer', 'schemeAdmin'],
    color: 'red',
    description: 'Sub Divisional Officer only scheme',
  },
};
